import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Link,
} from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';
import { useAuth } from '../hooks/useAuth';

export default function TermsModal() {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      localStorage.setItem('simplify_agreed', 'true');
      setOpen(false);
      return;
    }
    const hasAgreed = localStorage.getItem('simplify_agreed');
    if (hasAgreed !== 'true') {
      setOpen(true);
    }
  }, [isAuthenticated]);

  const handleAgree = () => {
    localStorage.setItem('simplify_agreed', 'true');
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 5,
          p: 2,
        },
      }}
    >
      <DialogContent>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <SchoolIcon sx={{ fontSize: 80, color: 'primary.main' }} />
        </Box>

        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Terms of Use & Privacy Policy
        </Typography>

        <Typography variant="subtitle1" align="center" sx={{ color: '#F4B73F', fontWeight: 600, mb: 2 }}>
          Professional. Premium. Affordable.
        </Typography>

        <Typography variant="body2" paragraph>
          Before using our platform, please review and agree to our Terms and Privacy Policy:
        </Typography>

        <Box component="ul" sx={{ pl: 3, mb: 2 }}>
          <li>
            <Typography variant="body2">
              Access is for <strong>personal educational use only</strong>.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              All content is <strong>© 2025 Simplify Review Center Inc.</strong>
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Your <strong>name and email</strong> are collected solely for account access and updates.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Reproduction, sharing, or resale of content is strictly prohibited.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              No guarantees are made regarding exam outcomes or passing scores.
            </Typography>
          </li>
        </Box>

        <Typography variant="body2" paragraph>
          Read the full{' '}
          <Link 
            href="/legal" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ 
              color: '#34C6C3', 
              fontWeight: 600,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              }
            }}
            onClick={(e) => {
              e.preventDefault();
              window.open('/legal', '_blank', 'noopener,noreferrer');
            }}
          >
            Legal Policy
          </Link>
          .
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              sx={{ color: 'primary.main' }}
            />
          }
          label={
            <Typography variant="body2">
              I agree to the Terms of Use and Privacy Policy.
            </Typography>
          }
          sx={{ mt: 2 }}
        />

        <Button
          variant="contained"
          fullWidth
          disabled={!agreed}
          onClick={handleAgree}
          sx={{
            mt: 2,
            bgcolor: '#34C6C3',
            color: 'white',
            fontWeight: 600,
            py: 1.5,
            borderRadius: 2,
            '&:hover': {
              bgcolor: '#F4B73F',
              color: '#0C2D57',
            },
            '&:disabled': {
              bgcolor: '#ccc',
            },
          }}
        >
          I Agree & Continue
        </Button>

        <Typography variant="caption" align="center" display="block" sx={{ mt: 2, color: 'text.secondary' }}>
          © 2025 Simplify Review Center Inc. | Prometric RN Exam Guide
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
